import { EndpointCall, retrieve } from "components/http/endpoint";
import { ApiUriPrefix_v1 } from "../apiUriPrefix";


const ClubsApiUri = ApiUriPrefix_v1 + "clubs";

function apiGetClub(id: number): EndpointCall {
    const uri = `${ClubsApiUri}/${id}`;
    return retrieve(uri, null);
}

export {
    apiGetClub,
}
